import { formatTranslation } from '@/core/oddsApi/helpers/formatTranslation';
import type { TournamentGroupsQuery } from '@/core/oddsApi/oddsApiType';
import type { IGroup } from '@/interface/tournamentCenter';

type TournamentGroupItem = TournamentGroupsQuery['tournamentGroups'][number];

export function formatTournamentGroup(group: TournamentGroupItem): IGroup {
    return {
        groupName: group.groupName,
        teamList: group.teamList.map(team => ({
            id: team.id,
            name: team.teamName.map(formatTranslation),
            played: team.played,
            won: team.won,
            drawn: team.drawn,
            lost: team.lost,
            goalDifference: team.goalDifference,
            points: team.points,
            ranking: team.ranking,
            isQualified: team.isQualified,
            countryName: team.countryName ?? '',
        })),
    };
}
